import React, { useContext } from 'react';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import TableWithState from '../../components/TableWithState/TableWithState';
import { ETables } from '../../types/enums/ETables';
import { NSCustomers } from '../../types/interfaces/NSCustomers';
import { SessionContext } from '../../contexts/session/SessionContext';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import { format } from 'date-fns';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ReportGenerator from './components/ReportGenerator';

const Customers = () => {
  const { permissions } = useContext(SessionContext);
  const cellStyleHandler = useCellStatusStyleHandler();

  const dataFormatter = (dataTable: NSCustomers.ITableItem[]): NSCustomers.IFormattedItem[] =>
    dataTable.map((table) => ({
      _id: table._id,
      status: table.status.current,
      name: table.name,
      email: table.email,
      carrierSubscriberReference: table.carrierSubscriberReference,
      origin: table.origin,
      registrationDate: format(new Date(table.registrationDate), 'yyyy-MM-dd'),
      delete: <RemoveCircleIcon style={{ marginLeft: 10, color: 'red', cursor: 'pointer' }} />,
    }));

  const columns = useColumnsHeaders([
    { accessorAsHeader: 'status' },
    { accessorAsHeader: '_id' },
    { accessorAsHeader: 'name' },
    { accessorAsHeader: 'email' },
    { accessorAsHeader: 'carrierSubscriberReference' },
    { accessorAsHeader: 'origin' },
    { accessorAsHeader: 'registrationDate' },
    { accessorAsHeader: 'delete' },
  ]);

  const host: string = window.location.host;

  const showRemoveEsims: boolean =
    host === 'wndr-staging.azurewebsites.net' || host === 'localhost:3000' || host === 'localhost:3001';

  return (
    <TableWithState
      tableName={ETables.Customers}
      dataFormatter={dataFormatter}
      columns={columns}
      cellStyleHandler={cellStyleHandler}
      addable={permissions.packages.edit}
      removeEsims={showRemoveEsims}
      actions={<ReportGenerator />}
    />
  );
};

export default Customers;
